import React from 'react';

interface LoadingPanelProps {
  message?: string;
}

export const LoadingPanel: React.FC<LoadingPanelProps> = ({ message = 'Loading...' }) => (
  <div className="adm-loading">
    <div className="adm-spinner" />
    <span>{message}</span>
  </div>
);

interface ErrorPanelProps {
  message: string;
  onRetry?: () => void;
}

export const ErrorPanel: React.FC<ErrorPanelProps> = ({ message, onRetry }) => (
  <div className="adm-error-panel">
    <span style={{ color: '#DC3545', fontWeight: 600 }}>Error:</span> {message}
    {onRetry && (
      <button className="adm-btn adm-btn-sm" onClick={onRetry} style={{ marginLeft: 12 }}>
        Retry
      </button>
    )}
  </div>
);
